import { gql } from "@apollo/client";

export default gql`
  mutation alignGoalMutation($goalId: Int!, $parentGoalId: Int) {
    alignGoal(goalId: $goalId, parentGoalId: $parentGoalId) {
      goal {
        id
        ... on GoalArtifactNode {
          basicChildGoals {
            edges {
              node {
                id
              }
            }
          }
          parentGoal {
            id
            basicChildGoals {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
      previousParentGoal {
        id
        ... on GoalArtifactNode {
          basicChildGoals {
            edges {
              node {
                id
              }
            }
          }
          parentGoal {
            id
          }
        }
      }
    }
  }
`;
